import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
export default class ModuleQuiz extends GenexLMSModel {
    static entity = 'moduleQuiz'
    static primaryKey = ['module_id', 'quiz_id']
    static fields() {
        return {
            quiz_id: this.attr(null),
            module_id: this.attr(null),
            order: this.attr(null),
            completed:this.attr(0)
        }
    }

}
